export default {
  parentToShare: {}, 
}